import React from 'react';
import { Redirect } from 'react-router-dom';

class PaginaInicio extends React.Component {
    
    constructor(props){
        super(props);
        this.state = { path : this.props.servicio.getPath() }
    }


    render(){
        return this.state.path!==undefined?<Redirect to={this.state.path} />:"";
    }
}

export default PaginaInicio;